import axiosInstance from './axiosInstance';

const ProjectTaskService = {
    getByDate: async (date) => {
        const response = await axiosInstance.get(`/api/project-tasks?date=${date}`);
        return response.data;
    },
    getByDateRange: async (from, to) => {
        const response = await axiosInstance.get(`/api/project-tasks?from=${from}&to=${to}`);
        return response.data;
    },
    getByProject: async (projectId) => {
        const response = await axiosInstance.get(`/api/project-tasks/by-project/${projectId}`);
        return response.data;
    },
    create: async (task) => {
        const response = await axiosInstance.post('/api/project-tasks', task);
        return response.data;
    },
    update: async (id, task) => {
        const response = await axiosInstance.put(`/api/project-tasks/${id}`, task);
        return response.data;
    },
    delete: async (id) => {
        await axiosInstance.delete(`/api/project-tasks/${id}`);
    },
    getMyTasks: async (date) => {
        const response = await axiosInstance.get(`/api/project-tasks/my-tasks?date=${date}`);
        return response.data;
    },
    getMyTasksRange: async (from, to) => {
        const response = await axiosInstance.get(`/api/project-tasks/my-tasks?from=${from}&to=${to}`);
        return response.data;
    },
    updateStatus: async (id, status) => {
        const response = await axiosInstance.patch(`/api/project-tasks/${id}/status`, { status });
        return response.data;
    },
    getComments: async (taskId) => {
        const response = await axiosInstance.get(`/api/project-tasks/${taskId}/comments`);
        return response.data;
    },
    addComment: async (taskId, content) => {
        const response = await axiosInstance.post(`/api/project-tasks/${taskId}/comments`, { content });
        return response.data;
    },
    updateComment: async (taskId, commentId, content) => {
        const response = await axiosInstance.put(`/api/project-tasks/${taskId}/comments/${commentId}`, { content });
        return response.data;
    },
    deleteComment: async (taskId, commentId) => {
        await axiosInstance.delete(`/api/project-tasks/${taskId}/comments/${commentId}`);
    },
};

export default ProjectTaskService;
